import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import InfoCompany from "./InfoCompany";
import ImportFile from "./Document";
import ClassifyIcms from "./Classify/Icms";
import ClassifyPisCofins from "./Classify/PisCofins";
import Result from "./Result";
import { PageHeader, Tabs } from "antd";
import { getCompany } from "../actions";
import { getProducts as getPisCofins } from "./Classify/PisCofins/actions";
import { getProducts as getIcms } from "./Classify/Icms/actions";
import { getResults } from "./Result/actions";
import { maskCnpj } from "../../helpers/functions";

import "../../styles/css/pages/company/styles.css";

const TabPane = Tabs.TabPane;

class Company extends Component {
  constructor() {
    super();
    this.state = {
      company: {
        Id: JSON.parse(sessionStorage.getItem("eRecuperadorCompany"))?.Id,
        RazaoSocial: JSON.parse(sessionStorage.getItem("eRecuperadorCompany"))
          ?.RazaoSocial,
        Cnpj: JSON.parse(sessionStorage.getItem("eRecuperadorCompany"))?.Cnpj,
      },
      activeTab: sessionStorage.getItem("eRecuperadorActiveTabCompany") || "2",
      icmsModule: JSON.parse(sessionStorage.getItem("icmsModule")),
    };

    this.changeActiveTab = this.changeActiveTab.bind(this);
  }

  componentDidMount() {
    document.title = "e-Recuperador - Empresa";
  }

  async componentDidUpdate(prevProps) {
    const cnpjPrev = prevProps.match.params.cnpj;
    const forceUpdatePrev = prevProps.forceUpdate;
    const { cnpj } = this.props.match.params;
    const {
      periodPis,
      periodIcms,
      statusErrorPis,
      statusErrorIcms,
      status,
      statusPis,
      statusIcms,
      companies,
      forceUpdate,
    } = this.props;
    const { icmsModule } = this.state;
    const company = JSON.parse(sessionStorage.getItem("eRecuperadorCompany"));
    let newCompany = { ...company };

    if (newCompany.Cnpj !== cnpj) {
      newCompany = await (companies || []).find((item) => item.Cnpj === cnpj);
      sessionStorage.setItem("eRecuperadorCompany", JSON.stringify(newCompany));
    }

    const isforceUpdate = (forceUpdatePrev + 1) === forceUpdate;

    if (isforceUpdate || newCompany?.Cnpj !== cnpjPrev || company?.Cnpj !== cnpjPrev) {

      this.setState(
        {
          company: newCompany,
          activeTab:
            sessionStorage.getItem("eRecuperadorActiveTabCompany") || "2",
        },
        () => {
          if (icmsModule) this.props.getIcms();
          this.props.getPisCofins();
          this.props.getResults();
        }
      );
    }

    if (status === 200 || statusIcms === 200 || statusPis === 200) {
      let extraData;

      if (statusErrorPis) {
        extraData = { status: statusErrorPis };
        if (periodPis) {
          extraData = {
            ...extraData,
            month: periodPis.Mes,
            year: periodPis.Ano,
          };
        }
        this.props.getPisCofins("", extraData);
      } else if (statusErrorIcms) {
        extraData = { status: statusErrorIcms };
        if (periodIcms) {
          extraData = {
            ...extraData,
            month: periodIcms.Mes,
            year: periodIcms.Ano,
          };
        }
        this.props.getIcms("", extraData);
      }

      this.props.getResults();
    }
  }

  changeActiveTab(key) {
    this.setState({ activeTab: key });
    sessionStorage.setItem("eRecuperadorActiveTabCompany", key);

    if (key === "1") {
      this.props.getCompany();
    }
  }

  backToClassify = async (month, year, status) => {
    const data = {
      month: month,
      year: year,
      status: status,
    };

    if (status === 3 || status === 4) {
      await this.changeActiveTab("3");
      this.props.getPisCofins(null, data);
    } else if (status === 5 || status === 6) {
      await this.changeActiveTab("5");
      this.props.getIcms(null, data);
    }
  };

  render() {
    const { company, activeTab, icmsModule } = this.state;
    const { history, forceUpdate } = this.props;

    return (
      <>
        <PageHeader
          onBack={() => history.push("/recuperacao")}
          title={company.RazaoSocial}
          subTitle={maskCnpj(company.Cnpj)}
        />

        <section className="products">
          <Tabs
            className="ant-tabs--custom"
            activeKey={activeTab}
            type="card"
            onChange={this.changeActiveTab}
          >
            <TabPane tab="Informações cadastrais" key="1">
              <InfoCompany />
            </TabPane>
            <TabPane tab="Documentos" key="2">
              <ImportFile changeActiveTab={this.changeActiveTab} />
            </TabPane>
            <TabPane
              tab={`Classificação fiscal ${icmsModule ? "PIS/COFINS" : ""}`}
              key="3"
            >
              <ClassifyPisCofins
                key={`ClassifyPisCofins-${forceUpdate}`}
                ClassifyIcms
                changeActiveTab={this.changeActiveTab}
              />
            </TabPane>
            {icmsModule ? (
              <TabPane tab="Classificação fiscal ICMS/ICMS ST" key="5">
                <ClassifyIcms
                  key={`ClassifyIcms-${forceUpdate}`}
                  changeActiveTab={this.changeActiveTab}
                />
              </TabPane>
            ) : null}
            <TabPane tab="Resultados" key="4">
              <Result
                key={`Result-${forceUpdate}`}
                backToClassify={this.backToClassify}
              />
            </TabPane>
          </Tabs>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  periodPis: state.pisCofins.period,
  periodIcms: state.icms.period,
  statusErrorPis: state.pisCofins.statusError,
  statusErrorIcms: state.icms.statusError,
  statusPis: state.pisCofins.status,
  statusIcms: state.icms.status,
  status: state.products.status,
  companies: state.companies.list,
  forceUpdate: state.importacao.forceUpdate,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { getCompany, getPisCofins, getIcms, getResults },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Company));
